export const ANIMAL = {
  nickname: 'PRODUCTS.ANIMAL.nickname',
  propertiesProductsList: {
  name: 'animalList',
    properties: [
      { name: 'animalBreed', key: 'ANIMAL_BREED', group: 'INSURANCE_INFO' },
      { name: 'animalType', key: 'ANIMAL_TYPE', group: 'INSURANCE_INFO' },
      { name: 'animalSIIllness', key: 'ANIMAL_ILLNESS_SCOOPR', group: 'INSURANCE_INFO' },
      { name: 'animalSIDeath', key: 'ANIMAL_DEATH_SCOOPR', group: 'INSURANCE_INFO' },
      { name: 'animalBirthYear', key: 'ANIMAL_BIRTH_YEAR', group: 'OBJECT_INFO' }
    ]
  },
  properties: [
    { name: 'animalBreed', key: 'ANIMAL_BREED', group: 'INSURANCE_INFO' },
    { name: 'animalType', key: 'ANIMAL_TYPE', group: 'INSURANCE_INFO' },
    { name: 'animalSIIllness', key: 'ANIMAL_ILLNESS_SCOOPR', group: 'INSURANCE_INFO' },
    { name: 'animalSIDeath', key: 'ANIMAL_DEATH_SCOOPR', group: 'INSURANCE_INFO' },
    { name: 'animalBirthYear', key: 'ANIMAL_BIRTH_YEAR', group: 'OBJECT_INFO' }
  ],
  icon: 'animal'
};
